import type { IStatusProps } from 'shared/ui/Status'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations/api/types'

const statuses: Record<IAutomationLogExecutionStatus, IStatusProps> = {
  failed: {
    title: 'Failed',
    icon: 'closeCircle',
    emphasis: 'high',
    intent: 'negative',
  },
  success: {
    title: 'Success',
    icon: 'check2',
    emphasis: 'high',
    intent: 'positive',
  },
}

export default statuses
